module.exports = __webpack_public_path__ + "static/media/down.a2e6ce24.svg";